import React from 'react';

// Components
import { RoundedPastille } from '@/views/components/misc';

// Libraries
import classNames from 'classnames';

interface HistoricalScenariosFilterDropdownProps {
  buttonRef?: React.RefObject<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  isOpen?: boolean;
  label: string;
  onClick: () => void;
  totalSelected?: number;
}

const HistoricalScenariosFilterDropdown: React.FC<HistoricalScenariosFilterDropdownProps> = ({
  buttonRef,
  className,
  disabled = false,
  isOpen = false,
  label,
  onClick,
  totalSelected = 0,
}) => {
  const classes = classNames(
    'filter-button',
    {
      focused: isOpen,
      active: totalSelected > 0 || false,
    },
    className,
  );

  return (
    <button aria-expanded={isOpen} aria-haspopup="listbox" className={classes} disabled={disabled} onClick={onClick} ref={buttonRef} type="button">
      <div className="flex-grow-1 filter-text">
        <span>{label}</span>
      </div>
      <div className="filter-label">{!totalSelected || totalSelected === 0 ? null : <RoundedPastille>{totalSelected.toString()}</RoundedPastille>}</div>
      <div className="dropdown-trigger">
        <i className={`icon-ds-chevron-${!isOpen ? 'down' : 'up'}`} />
      </div>
    </button>
  );
};

export default HistoricalScenariosFilterDropdown;
